
import { MarpolModel } from '../models/marpol-zones-model';
import { ZoneFeature } from '../models/zones-base-interfaces';
import { ZoneLayerBase } from './zone-layer-base';

export class MarpolLayer extends ZoneLayerBase {
    async getZones(): Promise<ZoneFeature[]> {
        const zones = await MarpolModel!.getMarpolZones();
        return zones || [];
    }
    
    zoneId: string = "MarpolLayer";
}